import {HyperDropTooltip} from "./components/HyperDropTooltip";

let tooltipInstances: HyperDropTooltip[] = [];

export function initTooltips(container: HTMLElement | Document = document): HyperDropTooltip[] {
  const tooltips = container.querySelectorAll<HTMLElement>('.tooltip-container');
  const newInstances: HyperDropTooltip[] = [];

  for (let tooltip of tooltips) {
    if (tooltip.querySelector(".custom-tooltip")) {
      const instance = new HyperDropTooltip({
        elements: {
          trigger: tooltip,
          tooltip: tooltip.querySelector(".custom-tooltip")
        },
      });
      newInstances.push(instance);
      tooltipInstances.push(instance);
    }
  }

  //console.log('Initialized tooltips:', newInstances.length);
  return newInstances;
}

// Initialize on page load
initTooltips();
if (window.Drupal) {
  window.Drupal.initTooltips = initTooltips;
}
